<script setup lang="ts">
// Página necessária para a integração Endorphina
definePageMeta({
  layout: 'blank',
});

const router = useRouter();

const reloadPage = () => {
  if (!import.meta.client) {
    return;
  }

  if (window && window.top) {
    window?.top.location.reload();
  } else {
    router.go(0);
  }
};
</script>

<template>
  <ClientOnly>
    <div :class="$style.gameError">
      <div :class="$style.content">
        <NuxtIcon name="exclamation" />
        <h2>
          {{ $t('casino.game.error.title') }}
        </h2>
        <h3>
          {{ $t('casino.game.error.subtitle') }}
        </h3>
        <button @click="reloadPage">
          <NuxtIcon name="sync" />
          {{ $t('casino.game.error.button') }}
        </button>
      </div>
    </div>
  </ClientOnly>
</template>

<style module lang="scss">
.gameError {
  @apply w-full h-full p-5 flex justify-center items-center bg-error text-white;
  .content {
    @apply flex flex-col gap-4 items-center justify-center leading-3;
    svg {
      @apply text-6xl opacity-70;
    }
    h2 {
      @apply text-2xl font-bold leading-3;
    }
    h3 {
      @apply text-xl font-semibold leading-3;
    }
    button {
      @apply bg-white text-error px-5 py-2 rounded-full text-sm font-semibold flex items-center justify-center gap-2;
      svg {
        @apply text-xs;
      }
    }
  }
}
</style>
